import { ComponentType, ReactNode } from 'react';
import filterChildrenByType from './_filterChildrenByType';

const findChildByType = <
  Type extends ComponentType<{ children?: any }> & { type: Symbol }
>(children: ReactNode | Function, Component: Type) => {
  const childrenByType = filterChildrenByType<Type>(children, Component);
  return childrenByType[0];
};

/**
 * @visibleName findChildByType
 * @component
 */
export default findChildByType;
